import { useOrganization } from './useOrganizations';

// import logos
import wsLogoFlorida from '../assets/images/wonderschool/FDOE_Logo.png';
import wsLogo from '../assets/images/wonderschool/logo-base.png';
const FLORIDA_ID = import.meta.env.VITE_FLORIDA_NETWORK_ID;

// Function return Logo URL/Logo
export function useNetworkLogo(): string {
  const organization = useOrganization();

  if (organization?.networks?.length && organization?.networks?.includes(FLORIDA_ID)) {
    return wsLogoFlorida;
  }
  return wsLogo;
}
